import React, { useState, useRef, useEffect } from 'react';
import { HiOutlineChevronDown } from 'react-icons/hi';
import { OptionWithIcon } from '../../interfaces/OptionWithIcon';
import { ListSelectBox, SelectBox } from './CustomInput/styleGuide';
import { defaultBorder, defaultColors } from '../../styles/style-guide';
import { useAppSelector } from '../../hooks/hooksRedux';
import { RootState } from '../../store';

interface Props {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  selectedItem: OptionWithIcon;
  setSelectedItem: (params: any) => any;
  items: OptionWithIcon[];
}

const CustomSelectWithIcon: React.FC<Props> = (props: Props) => {
  const [opened, setOpened] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const {colors, border} = useAppSelector((state: RootState) => state.styleGuide.data);
  const primaryColor = colors.primary || defaultColors.primary;
  const primaryBorderColor = border.primary || defaultBorder.primary;

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpened(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpened(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="relative" onClick={() => setOpened(!opened)}>
      <SelectBox $colorText={primaryColor} $borderColor={primaryBorderColor}>
        <img src={props.selectedItem.src} />
        {props.selectedItem.label}
        <HiOutlineChevronDown color={primaryColor} />
      </SelectBox>

      {opened && (
        <div className="absolute left-0 top-[40px] w-full">
          <ul className="w-full shadow-md">
            {props.items.map((element, index) => (
              <ListSelectBox $colorText={primaryColor} key={index} onClick={() => props.setSelectedItem(element)}>
                <img src={element.src} />
                {element.label}
              </ListSelectBox>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export { CustomSelectWithIcon };
